const CHECKOUT_STORAGE_KEY = "zeaMaysCheckoutDraft";

export const saveCheckoutDraft = (draft) => {
  localStorage.setItem(CHECKOUT_STORAGE_KEY, JSON.stringify(draft));
};

export const readCheckoutDraft = () => {
  try {
    const savedDraft = localStorage.getItem(CHECKOUT_STORAGE_KEY);
    return savedDraft ? JSON.parse(savedDraft) : null;
  } catch (error) {
    console.error("Error reading checkout draft:", error);
    return null;
  }
};

export const clearCheckoutDraft = () => {
  localStorage.removeItem(CHECKOUT_STORAGE_KEY);
};

export const savePendingCheckoutReference = (reference) => {
  const currentDraft = readCheckoutDraft() || {};

  saveCheckoutDraft({
    ...currentDraft,
    pendingReference: reference,
  });
};

export const clearPendingCheckoutReference = () => {
  const currentDraft = readCheckoutDraft();

  if (!currentDraft) {
    return;
  }

  const { pendingReference, ...rest } = currentDraft;
  saveCheckoutDraft(rest);
};
